import SigninForm from "./LoginForm";
import "../../Auth/Auth.css";
import { connect } from "react-redux";
import { login } from "../../../redux/actions/authAction";
import { pageText } from "../../../utils/pageText";

function Login(props) {
  const { role } = props; // 从props中获取role

  return (
    <div className="modern-signin-container">
      {/* 左侧品牌区域 */}
      <div className="signin-brand-section">
        <div className="brand-content">
          <div className="brand-header">
            <div className="brand-logo">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <rect width="48" height="48" rx="12" fill="#667eea"/>
                <path d="M16 24L22 30L32 18" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h1 className="brand-title">Kneron MLOPs</h1>
            <p className="brand-subtitle">{pageText("A comprehensive data annotation and training platform")}</p>
          </div>
          
          <div className="brand-features">
            <div className="feature-card">
              <h3>{pageText("Smart Annotation")}</h3>
              <p>{pageText("Integrated with CVAT and Label Studio, supporting multiple data types annotation")}</p>
            </div>
            <div className="feature-card">
              <h3>{pageText("Model Training")}</h3>
              <p>{pageText("Support training and evaluation of various deep learning models like YOLO, ResNet")}</p>
            </div>
            <div className="feature-card">
              <h3>{pageText("Team Collaboration")}</h3>
              <p>{pageText("Organization-based permission management for team collaboration and data sharing")}</p>
            </div>
          </div>
        </div>
      </div>

      {/* 右侧登录表单区域 */}
      <div className="signin-form-section">
        <div className="form-wrapper">
          <SigninForm authActions={props.authActions} role={role} />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    role: state.auth.role, // 从Redux store中获取role的值
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: {
      login: (userData) => dispatch(login(userData)),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
